import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/pt-br";

const PracticesHome = (props) => {
  const [practices, setPractices] = useState([]);

  useEffect(() => {
    async function exibir() {
      let payload = apiGet("/practices");

      setPractices((await payload).data.data);
    }
    exibir();
  }, []);

  var practicesSubset = null;

  if (practices && practices.length) {
    practicesSubset = practices.slice(0, props.practicesToShow);
  }

  return (
    <>
      <div>
        {practicesSubset
          ? practicesSubset.map((practice) => {
              return (
                <div className="card mb-3" key={practice.practice_id}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card-body">
                        <h5 className="card-title">{practice.title}</h5>
                        <p className="card-text m-0">
                          <small className="text-muted">
                            {practice.place} -{" "}
                            {moment(practice.when).format("LL")}
                          </small>
                        </p>
                        <p className="card-text m-0">
                          <small className="text-muted">
                            {practice.subject}
                          </small>
                        </p>
                        <p className="card-text m-0">
                          <small className="text-muted">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: practice.abstract,
                              }}
                            ></span>
                          </small>
                        </p>
                        <p className="card-text m-0">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={practice.link}
                          >
                            Leia mais.
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </>
  );
};

export default PracticesHome;
